<template>
  <header
    class="app-layout-header fixed"
  >
    <div class="app-layout-header-inner">
      <div class="app-layout-header-nav" ref="header">
        <div class="app-layout-header-nav-left padding-left-10">
          <div ref="menu-side">
            <a
              class="icon_log"
              target="_blank"
              href="http://www.ibaibu.com/"
            ></a>

            <!-- 平台 -->
            <el-select
              class="margin-left-10"
              v-model="queryBizChannel"
              @change="handleBizChannelChange"
              v-if="bizChannelVisible"
            >
            <el-option
              v-for="item in bizChannelList"
              :key="item.key"
              :label="item.name"
              :value="item.key"
            ></el-option>
            </el-select>

            <!-- 应用 || 服务名称 -->
            <el-select
              v-if="envSelectorVisible"
              :style="{width: '180px'}"
              class="margin-left-10"
              :key="queryOptionsSource.length"
              v-model="querySource"
              placeholder="请选择"
              :disabled="serverSelectorDisabled"
              filterable
            >
              <el-option
                v-for="item in queryOptionsSource"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              ></el-option>
            </el-select>

            <!-- 环境 -->
            <el-select
              v-if="envSelectorEnvVisible"
              style="width: 150px;"
              class="margin-left-10 env-select"
              :class="{ 'is-current-env': isCurrentEnv}"
              @change="handleEnvChange"
              :disabled="envSelectorDisabled"
              v-model="queryEnv"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in envList"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              >
                <span>
                  <i
                    v-if="item.currentFlow"
                    class="el-icon-success margin-right-5"
                    style="color: #F56C6C;"
                  ></i>
                  {{ item.name }}
                </span>
              </el-option>
            </el-select>

          </div>
          <div class="margin-left-10 flex-1 overflow-hidden">
            <el-popover
              width="120"
              placement="bottom"
              :offset="100"
              trigger="hover"
              id="flow-list"
            >
              <el-row>
                <el-col
                  v-for="(item, index) in flowList"
                  :key="`flowList-${index}`"
                  :class="{'margin-top-10': index, 'font-size-12': true}"
                  :style="{
                    color: !item.env ? '#999' : item.env === 'blue' ? '#409EFF' : '#67C23A',
                  }"
                >
                  {{ item.bizChannelName }}({{ !item.env ? '' : item.env === 'blue' ? '蓝' : '绿' }})
                </el-col>
              </el-row>
              <div slot="reference">
                <el-row
                  :style="{
                    'text-align': 'left',
                    'overflow': 'hidden',
                    'white-space': 'nowrap',
                    'text-overflow': 'ellipsis',
                  }"
                >
                  <span
                    v-for="(item, index) in flowList"
                    :key="`flowList-${index}`"
                    class="env-point"
                    :style="{
                      color: !item.env ? '#999' : item.env === 'blue' ? '#409EFF' : '#67C23A',
                    }"
                  >
                    {{ item.bizChannelName }}
                    ({{ !item.env ? '' : item.env === 'blue' ? '蓝' : '绿' }})
                  </span>
                </el-row>
              </div>
            </el-popover>
          </div>
        </div>
        <div ref="operation">
          <el-dropdown v-if="currentUserName">
            <span class="app-layout-user-name">
              {{ currentUserName }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item @click.native="handleChangePassword">
                修改密码
              </el-dropdown-item> -->
              <el-dropdown-item @click.native="handleLogout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <i class="el-icon-switch-button app-layout-exit" v-else @click="handleLogout" />
        </div>

      </div>

    </div>
    <ModifyPassword v-model="passwordVisible" @callback="logout" />
  </header>
</template>

<script>
import {
  mapGetters, mapActions,
} from 'vuex';
import { queryServerInfo } from '@/api/analyze';
import { AUTH_TOKEN } from '@/data/auth';
import { logout } from '@/api/auth';
import { USER_INFO } from '@/data/user';
import ModifyPassword from '../modify-password/index.vue';

export default {
  name: 'AppHeader',
  components: {
    ModifyPassword,
  },
  data() {
    return {
      passwordVisible: false,
      serverLoading: false,
      reloadSelect: false,
      isCurrentEnv: false,
      account: {
        userName: '',
        avatar:
          'https://s3-imfile.feishucdn.com/static-resource/v1/00bbd21d-4271-4f84-9560-3ac82b0bd19g~?image_size=100x100&cut_type=&quality=&format=png&sticker_format=.webp',
      },
      languages: [
        { name: '中文简体', lang: 'zh' },
        { name: 'English', lang: 'en' },
      ],
      query: {
        source: '',
        env: '',
      },
    };
  },
  computed: {
    ...mapGetters(
      'app',
      [
        'source',
        'flowList',
        'env',
        'envList',
        'sourceList',
        'serverName',
        'serverList',
        'bizChannelList',
      ],
    ),
    queryOptionsSource() {
      const list = this.getIsUseServerInfoPage() ? this.serverList : this.sourceList;
      if (!list.some((item) => item.key === this.querySource)) {
        // 没有值
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.querySource = list[0]?.key || '';
      }
      return list;
    },
    currentUserName() {
      const user = window.localStorage.getItem(USER_INFO);
      if (user) {
        return JSON.parse(user).userName;
      }
      return '';
    },
    serverSelectorDisabled() {
      return (this.$route.meta?.isDisabledServerInfo ?? false);
    },
    bizChannelVisible() {
      const {
        isUseEnvInfo = false,
        isUseServerInfo = false,
        isUseAppInfo = false,
      } = this.$route.meta || {};
      return !(!isUseEnvInfo && !isUseServerInfo && !isUseAppInfo);
    },
    envSelectorEnvVisible() {
      return (this.$route.meta?.isUseEnvInfo ?? false)
        || (this.$route.meta?.isUseServerInfo ?? false)
        || (this.$route.meta?.isUseAppInfo ?? false);
    },
    envSelectorDisabled() {
      return (this.$route.meta?.isDisabledAppInfo ?? false);
    },
    envSelectorVisible() {
      // eslint-disable-next-line max-len
      return (this.$route.meta?.isUseServerInfo ?? false) || (this.$route.meta?.isUseAppInfo ?? false);
    },
    // 选中的来源
    querySource: {
      get() {
        return this.getIsUseServerInfoPage() ? this.serverName : Number(this.source) || '';
      },
      set(newValue) {
        // eslint-disable-next-line no-unused-expressions
        this.getIsUseServerInfoPage()
          ? this.setServerName(newValue)
          : this.setSource(newValue);
      },
    },

    // 选中的平台
    queryBizChannel: {
      get() {
        return this.$store.getters['app/bizChannel'];
      },
      set(newValue) {
        this.$store.dispatch('app/setBizChannel', newValue);
      },
    },

    // 展示当前流量
    currentFlow() {
      const flow = this.flowList.filter((item) => this.env.includes(item.bizChannel))[0];
      return `
      <span
        style="color: ${!flow.env ? '#999' : `${flow.env === 'blue' ? '#409EFF' : '#67C23A'}`}"
      >${flow.bizChannelName}(${!flow.env ? '/' : `${flow.env === 'blue' ? '蓝' : '绿'}`})</span>`;
    },

    // 选中的环境
    queryEnv: {
      get() {
        return this.env;
      },
      set(newValue) {
        this.setEnv(newValue);
      },
    },
  },
  beforeDestroy() { },
  created() {},
  mounted() {
    this.handleCheckIsCurrentEnv();
  },
  watch: {
    envList() {
      this.$nextTick(() => {
        this.handleCheckIsCurrentEnv();
      });
    },
    source: {
      handler(e) {
        this.query.source = e;
      },
      immediate: true,
    },
    env: {
      handler(e) {
        this.query.env = e;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(
      'app',
      ['setSource', 'setEnv', 'setServerName', 'setServerList'],
    ),

    /**
     * 平台切换
     */
    handleBizChannelChange(value) {
      this.setServerName('');

      if (this.getIsUseServerInfoPage()) {
        this.queryServerInfo();
        return;
      }

      const items = this.bizChannelList.find((item) => item.key === value);
      if (items) {
        this.$store.dispatch('app/setSourceList', items?.sources || []);
        const [firstItem = { key: '' }] = items?.sources || [];
        const setValue = firstItem ? firstItem?.key || '' : '';
        this.$store.dispatch('app/setSource', setValue);
      }
    },

    renderBreadChild(parent, children) {
      if (children) {
        // eslint-disable-next-line no-shadow
        const child = children.find((child) => this.$route.path.indexOf(child.path) !== -1);
        if (child) {
          parent.push(child);
          return this.renderBreadChild(parent, child.children);
        }
      }
      return parent;
    },

    setQueryOptionsSource() {
      this.$nextTick(async () => {
        // eslint-disable-next-line no-unused-expressions
        this.getIsUseServerInfoPage()
          ? await this.queryServerInfo()
          : (this.queryOptionsSource = this.sourceList);
      });
    },

    handleChangePassword() {
      this.passwordVisible = true;
    },

    getIsUseServerInfoPage() {
      return this.$route.meta?.isUseServerInfo || false;
    },

    async queryServerInfo() {
      try {
        this.serverLoading = true;
        const { data } = await queryServerInfo({
          bizChannel: this.queryBizChannel,
        });

        // 处理数据
        let serverInfos = [
          ...data.serverInfos.map((item) => ({
            key: item.serverName,
            name: item.serverName,
          })),
        ];

        serverInfos = [
          {
            key: '',
            name: '全部服务',
          },
          ...serverInfos,
        ];

        this.reloadSelect = true;
        // eslint-disable-next-line no-return-assign
        setTimeout(() => this.reloadSelect = false, 0);

        this.setServerList(serverInfos);

        // 判断当前的参数
        if (!this.serverName && serverInfos.length > 0) {
          this.setServerName(serverInfos[0].key);
        }

        if (serverInfos.length === 0) {
          this.setServerName('');
        }
      } catch (e) {
        this.setServerName('');
      } finally {
        this.serverLoading = false;
      }
    },
    handleSourceChange() {
      this.setSource(this.query.source);
    },
    handleCheckIsCurrentEnv() {
      if (this.envList.length) {
        // eslint-disable-next-line no-shadow
        const item = this.envList.find((item) => item.currentFlow);
        if (item) {
          this.isCurrentEnv = item.key === this.queryEnv;
          return;
        }
      }
      this.isCurrentEnv = false;
    },
    handleEnvChange() {
      // this.setServerName('');

      this.$nextTick(async () => {
        if (this.getIsUseServerInfoPage()) {
          this.queryServerInfo();
        }
      });
      this.handleCheckIsCurrentEnv();
    },
    async logout() {
      window.localStorage.removeItem(AUTH_TOKEN);
      await logout();
      this.$router.replace({
        name: 'Login',
      });
    },
    /**
     * 退出登录
     */
    async handleLogout() {
      try {
        await this.$confirm('确定退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
        this.logout();
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>

<style lang="scss">

.env-select.is-current-env {
  .el-input {
    position: relative;
    font-family: element-icons!important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    color: #F56C6C;

    input {
      padding-left: 30px;
    }

    &:after {
      position: absolute;
      font-size: 16px;
      left: 10px;
      top: 50%;
      transform:translate(0, -50%);
      content: "\e79c";
    }
  }
}

</style>
<style lang="scss" scoped>
.app-layout {
  .env-point {
    margin-left: 10px;
    // width: 10px;
    // height: 10px;
    // background-color: #f90;
    // border-radius: 100%;
    width: auto;
    padding: 0 5px;
    font-weight: bold;
    font-size: 13px;
    height: 20px;
    line-height: 20px;
    cursor: pointer;
  }

  &-user-name {
     cursor: pointer;
     padding: 0 10px;
  }

  &-exit {
    padding-right: 20px;
    cursor: pointer;
    font-size: 18px;
    color: rgb(228, 132, 65);
  }
  // 头部
  &-header {
    height: $app-header-height;
    transition: width 0.2s;
    &::v-deep {
      .el-menu--horizontal {
        border: 0;
      }
    }
    &-inner {
      min-width: 725px;
      position: relative;
      z-index: 200;
    }

    &-nav {
      background: #fff;
      height: $app-header-height;
      line-height: $app-header-height;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.05);
      transition: width 0.2s;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &-left {
        min-width: $app-header-sider-width;
        display: flex;
        align-items: center;
        .icon_log {
          background: url("../../assets/logo-slog.png") no-repeat;
          background-size: contain;
          width: 30px;
          height: 30px;
          display: inline-block;
          vertical-align: middle;
        }
      }
      &-right {
        color: #808080;
        display: flex;
        align-items: center;
        position: relative;
        .el-badge {
          line-height: 20px;
          margin-right: 20px;
        }
        a {
          color: inherit;
        }
      }
    }

    .hamburger-container {
      padding: 0 20px;
      line-height: $app-header-height;
      cursor: pointer;
      transition: background 0.3s;
      -webkit-tap-highlight-color: transparent;
      float: left;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .breadcrumb-container {
      height: $app-header-height;
      line-height: $app-header-height;
      float: left;
    }

    .action {
      padding: 0 12px;
      display: inline-block;
      cursor: pointer;
      vertical-align: middle;
      font-size: 20px;
      transition: background-color 0.25s;

      &-button {
        cursor: pointer;
        position: relative;
        font-size: 22px;
        top: 0;
        color: #808080;
        height: $app-header-height;
        display: flex;
        justify-content: center;
        align-items: center;

        &-inner {
          height: 100%;
          display: flex;
          align-items: center;
        }
      }

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }

      .name {
        font-size: 14px;
        margin-left: 8px;
        vertical-align: middle;
        line-height: 1;
      }

      .avatar {
        display: block;
        width: 28px;
        height: 28px;
        border-radius: 100%;
        background-color: rgba(0, 0, 0, 0.05);
        line-height: 1;
      }

      .el-badge {
        line-height: normal;
        position: relative;
        top: -3px;
      }
    }

    // 固定头部
    &.fixed {
      .app-layout-header-inner {
        position: fixed;
        top: 0;
        left: 0;
        // left: $app-sider-width;
        width: 100%;
        z-index: 202;
        // width: calc(100% - #{$app-sider-width});
      }
    }
  }

  // 有 tags-view 的头部
  &-header-tags-view {
    height: $app-header-height + 34px;
  }
}

.el-menu-item {
  a {
    display: block;
  }
}
.breadcrumb-link {
  cursor: pointer !important;
}
.el-breadcrumb {
  font-size: 12px;
}
// .current-menu-txt {
//   position: absolute;
//   top: 17px;
//   left: 0;
//   right: 17px;
//   text-align: right;
//   font-size: 12px;
//   color: #ccc;
// }
</style>
